import fetchJsonp from 'fetch-jsonp';

export default class ZaikoCart {
  constructor(cont) {
    this.$ = cont;
    if (this.$.dataset.logic === 'reverse') {
      this.logic = 'reverse';
      console.log('logic: ', this.logic);
    } else {
      this.logic = 'normal';
    }

    // 商品情報
    if (this.$.dataset.shohincd) {
      this.shohincd = this.$.dataset.shohincd;
      this.itemJanArr = this.shohincd.split(',');
      this.itemBorder = this.$.dataset.border ? this.$.dataset.border : 10;
    }
    if (this.$.dataset.brc) {
      if(this.$.dataset.brc !== '') {
        this.brc = this.$.dataset.brc;
      } else {
        this.brc = 'brac010';
      }
    }else {
      this.brc = 'brac010';
    }

    // 景品情報
    if (this.$.querySelector('.js-zaiko-gift')) {
      this.giftInput = this.$.querySelector('.js-zaiko-gift');
      this.giftShohincd = this.giftInput.dataset.shohincd;
      this.giftJanArr = this.giftShohincd.split(',');
      this.giftBorder = this.giftInput.dataset.border ? this.giftInput.dataset.border : 10;
    }

    // 現在のドメイン
    this.domain = location.hostname;

    // カートリンク情報
    this.cartBaseURL = '/sw/auth/SWFG014120.seam?brc=' + this.brc + '&_kss_next_url=%2Fsw%2Fproducts%2Fauth%2FSWFG070220.seam%3FactionMethod%3D%2Fproducts%252Fauth%252FSWFG070220.xhtml%253AsWFG070220Action.addCartShohin';

    // 本番orSTG以外だったら本番ドメインをつける
    // if (this.domain.indexOf("shiseido.co.jp") === -1) {
    //   this.cartBaseURL = 'https://www.shiseido.co.jp' + this.cartBaseURL;
    // }

    this.cartParamKey = '%26sweb_shohin_cd%3D';

    if (this.$.querySelector('.js-zaiko-link')) {
      this.cartLinkArr = Array.from(this.$.querySelectorAll('.js-zaiko-link'));
    }

    // 在庫API情報
    this.apiPath = "/sw/products/SWFG070740.seam";
    this.janParamKey = '&shohin_cd=';

    this.initialize();

  }

  async initialize() {

    // カートリンク設置
    if (this.itemJanArr) {
      let cartParam = this.cartParamKey + this.itemJanArr.join(this.cartParamKey);
      let cartURL = this.cartBaseURL + cartParam + "%26online_shohin_ctlg_kbn%3D1%26keyword_flg%3D1";
      if (this.cartLinkArr) {
        this.cartLinkArr.forEach(link => {
          link.setAttribute('href', cartURL);
        });
      }
    }

    // カート計測onclick設置
    if (this.itemJanArr) {
      let scID = 'cartbtn_' + this.itemJanArr.join('_') + '_' + this.$.dataset.zaiko_serial;
      if (this.cartLinkArr) {
        this.cartLinkArr.forEach(link => {
          link.setAttribute('onclick', '_sc.gene_click(\'' + scID + '\',this.href);');
        });
      }
    }

    // ドメイン判定&API URLセット
    let apiURL = '';
    if (this.domain.indexOf("shiseido.co.jp") != -1) {
      apiURL = this.apiPath;
    } else {
      apiURL = 'https://www.shiseido.co.jp' + this.apiPath;
    }

    // 在庫判定文字列初期化
    let zaiko = '';
    let itemZaiko = '';
    let giftZaiko = '';

    // 商品在庫
    if (this.shohincd) {
      let itemParam = this.janParamKey + this.itemJanArr.join(this.janParamKey);
      itemParam = '?border=' + this.itemBorder + '&shohin_kbn=1' + itemParam;
      const itemRes = await fetchJsonp(apiURL + itemParam);
      const itemData = await itemRes.json();
      itemZaiko = itemData.map(function (value) {
        return value.zaiko_kbn;
      });
      zaiko += ',' + itemZaiko;
    }

    // 景品在庫
    if (this.giftShohincd) {
      let giftParam = this.janParamKey + this.giftJanArr.join(this.janParamKey);
      giftParam = '?border=' + this.giftBorder + '&shohin_kbn=2' + giftParam;
      const giftRes = await fetchJsonp(apiURL + giftParam);
      const giftData = await giftRes.json();
      giftZaiko = giftData.map(function (value) {
        return value.zaiko_kbn;
      });
      zaiko += ',' + giftZaiko;
    }

    // 該当要素表示
    const displayTarget = Array.from(this.$.querySelectorAll('.zaikokbn' + this.zaikoJudge(zaiko)));
    displayTarget.forEach(elm => {
      elm.style.display = 'block';
    })
    this.$.dataset.zaiko = this.zaikoJudge(zaiko);

    // 非活性エリア内のbutton/aをtab移動から外す（キーボード操作対応）
    if (this.zaikoJudge(zaiko) === 0 || this.zaikoJudge(zaiko) === 9) {
      const focusableElements = this.$.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      focusableElements.forEach((element) => {
        element.disabled = true;
        element.setAttribute('aria-disabled', true);
        element.setAttribute('tabindex', '-1');
      });
    }
  }

  zaikoJudge(str) {
    if (this.logic === 'reverse') {
      if (str.indexOf('1') != -1) {
        return 1;
      } else if (str.indexOf('2') != -1) {
        return 2;
      } else if (str.indexOf('0') != -1) {
        return 0;
      } else if (str.indexOf('9') != -1) {
        return 9;
      }
    } else {
      if (str.indexOf('9') != -1) {
        return 9;
      } else if (str.indexOf('0') != -1) {
        return 0;
      } else if (str.indexOf('2') != -1) {
        return 2;
      } else if (str.indexOf('1') != -1) {
        return 1;
      }
    }
  }
}

